import React from "react";
import { Container } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import { FiArrowUpRight } from "react-icons/fi";
import SocialMedia from "../SocialMedia/SocialMedia";
import TextCarousel from "../TextCarousel/TextCarousel";
import { navigationLinks } from "../../data/navigation";
import { CONTACT_FORM_EMAIL } from "../../utils/contactFormSubmission";
import { handleCurrentPageNavigation } from "../../utils/pageNavigation";
import logo from "../../Assets/logo-white.webp";
import "./Footer.scss";

const footerGroups = [
  { id: "explore", title: "Explore" },
  { id: "capabilities", title: "Capabilities" },
];

function FooterLink({ to, ...props }) {
  const location = useLocation();
  return <Link {...props} to={to} state={{ scrollToTop: true }}
    onClick={(event) => handleCurrentPageNavigation(event, location)} />;
}

function Footer() {
  const { pathname } = useLocation();
  const isSolutionPage = pathname.replace(/\/+$/, "") === "/solution";
  return (
    <div className={`footer-wrap${isSolutionPage ? " footer-wrap--solution" : ""}`}>
      {!isSolutionPage && <TextCarousel />}
      <footer className="footer mobile-type">
        <Container className="footer-container">
          <div className="footer-content">
            <div className="footer-brand-column">
              <FooterLink to="/" className="footer-logo" aria-label="Klean Leaf home">
                <img src={logo} alt="" width="56" height="56" />
                <span className="footer-brand">Klean Leaf</span>
              </FooterLink>
              <p className="footer-description">
                Private label laundry detergent sheets manufacturer.
              </p>
              <FooterLink to="/products" className="footer-product-link">
                Explore Products {pathname !== "/" && <FiArrowUpRight aria-hidden="true" focusable="false" />}
              </FooterLink>
            </div>

            <nav className="footer-navigation" aria-label="Footer navigation">
              {footerGroups.map(({ id, title }) => (
                <div className="footer-link-group" key={id}>
                  <h2 className="footer-heading">{title}</h2>
                  <ul>
                    {navigationLinks.filter((link) => link.footerGroup === id).map(({ to, label, footerLabel }) => (
                      <li key={to}>
                        <FooterLink to={to}>{footerLabel || label}</FooterLink>
                      </li>
                    ))}
                    {id === "capabilities" && (
                      <li><FooterLink to="/products?category=kit">Product kits</FooterLink></li>
                    )}
                  </ul>
                </div>
              ))}
            </nav>

            <div className="footer-contact">
              <h2 className="footer-heading">Get in touch</h2>
              <address>
                <a href={"mailto:" + CONTACT_FORM_EMAIL}>{CONTACT_FORM_EMAIL}</a>
                <a href="tel:+16149065129">614.906.5129</a>
                <FooterLink to="/contact">Contact us&nbsp;<span aria-hidden="true">→</span></FooterLink>
              </address>
              <div className="footer-socials">
                <SocialMedia />
              </div>
            </div>
          </div>

          <div className="footer-bottom">
            <small>© {new Date().getFullYear()} Klean Leaf. All rights reserved.</small>
          </div>
        </Container>
      </footer>
    </div>
  );
}

export default Footer;
